import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom"
import store from './store';
import { Provider } from 'react-redux';
import ContextProvider from "./components/context/ContextProvider"


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<ContextProvider>
  <Provider store={store}>
  <BrowserRouter >
    <App />
  </BrowserRouter>
  </Provider>
  </ContextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
